import { Card, CardContent } from "components/UI/Card";
import { Box, Image, Lightbulb, Target } from "lucide-react";
import { motion, Variants } from "framer-motion";
const steps = [
  {
    step: "Step 1",
    title: "Start with a Need",
    description: "Share your occasion, audience, or goal. We've got you.",
    icon: Target,
  },
  {
    step: "Step 2",
    title: "Explore Curated Ideas",
    description:
      "We suggest thoughtful, trend-aware gifting options tailored for impact.",
    icon: Lightbulb,
  },
  {
    step: "Step 3",
    title: "Visualize Your Picks",
    description: "Get branded mockups and themed catalogs to review or share.",
    icon: Image,
  },
  {
    step: "Step 4",
    title: "Hand It Over to Us",
    description:
      "We handle the complete journey from your requirements to final delivery.",
    icon: Box,
  },
];

const containerVariants: Variants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.4,
    },
  },
};

const cardVariants: Variants = {
  hidden: { opacity: 0, x: -60 },
  show: {
    opacity: 1,
    x: 0,
    transition: {
      type: "spring",
      stiffness: 150,
      damping: 10,
    },
  },
};

const SectionHowItWorks = () => {
  return (
    <section
      className="relative px-6 py-10 md:py-20 bg-gradient-to-b from-[#f9fbff] to-white"
      id="howitworks"
    >
      <div className="text-center max-w-3xl mx-auto mb-16">
        <h2 className="text-4xl md:text-5xl font-extrabold leading-snug md:leading-[1.25] font-inter text-secondary-gradient">
          Get Started <br /> The Smarter Way
        </h2>
        <p className="mt-4 text-gray-600 text-lg">
          A guided flow that helps you plan, explore, and connect, even if
          you're just figuring things out.
        </p>
      </div>

      <motion.div
        variants={containerVariants}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.1 }}
        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto"
      >
        {steps.map((item, index) => {
          const Icon = item.icon;
          return (
            <motion.div key={index} variants={cardVariants}>
              <Card className="bg-white/80 backdrop-blur rounded-2xl p-4 sm:p-6 shadow-md text-center flex flex-col justify-between h-full min-h-[260px] max-h-[350px]">
                <CardContent className="flex flex-col h-full">
                  {/* Step Badge */}
                  <div className="text-sm text-[#a4a4be] mb-3">
                    <span className="inline-block bg-[#f0efff] text-black font-semibold px-3 py-1 rounded-full text-xs sm:text-sm">
                      {item.step}
                    </span>
                  </div>

                  {/* Icon */}
                  <div className="flex justify-center mb-3">
                    <Icon size={40} className="text-blue-400 shrink-0" />
                  </div>

                  {/* Title */}
                  <h3 className="text-base sm:text-lg font-semibold text-[#3b3b66] mb-2 whitespace-nowrap">
                    {item.title}
                  </h3>

                  {/* Description */}
                  <p className="text-sm text-gray-500 text">
                    {item.description}
                  </p>
                </CardContent>
              </Card>
            </motion.div>
          );
        })}
      </motion.div>
    </section>
  );
};

export default SectionHowItWorks;
